'use client';

import { HeroSection } from 'components/birthday/HeroSection';
import { ProductSection } from 'components/invite';
import { useSearchParams } from 'next/navigation';
import { useRegionLocale } from 'contexts/RegionLocaleContext';

function Birthday() {
  const searchParams = useSearchParams();
  const { region: country } = useRegionLocale();
  const token = searchParams?.get('token') ?? null;

  const birthdayValues: Record<string, string | null> = {
    name: null,
    discount: null,
    expiryDate: null,
  };

  if (token) {
    const tokenString = decodeURIComponent(atob(token));
    const tokenSplit = tokenString.split('##');
    birthdayValues.name = tokenSplit[0];
    birthdayValues.expiryDate = tokenSplit[1];
    birthdayValues.discount = tokenSplit[2];

    console.log(birthdayValues.expiryDate);
    console.log(birthdayValues.discount);
  }

  // Check if discount is expired
  const isDiscountExpired =
    birthdayValues.expiryDate &&
    Date.now() > parseInt(birthdayValues.expiryDate);

  // Clear discount if expired
  if (isDiscountExpired) {
    birthdayValues.discount = null;
  }

  // Extract percentage from discount code (last 2 characters if they're numbers, otherwise default)
  const getDiscountPercentage = (discountCode: string) => {
    const lastTwoChars = discountCode.slice(-2);
    const percentage = parseInt(lastTwoChars);
    return !isNaN(percentage) && percentage > 0 && percentage <= 100
      ? percentage
      : 15;
  };

  // Format date range from expiry date
  const getDateRange = (expiryDate: string | null) => {
    if (!expiryDate) return null;

    const expiryTimestamp = parseInt(expiryDate);
    if (isNaN(expiryTimestamp)) return null;

    const expiryDateObj = new Date(expiryTimestamp);
    console.log('expiryDateObj');
    console.log(expiryDateObj);
    // const startDate = new Date(expiryTimestamp - (14 * 24 * 60 * 60 * 1000)); // 14 days before expiry

    const formatDate = (date: Date) => {
      const day = date.getDate();
      const month = date.toLocaleDateString('en-US', { month: 'short' });
      return `${day} ${month}`;
    };

    // const startFormatted = formatDate(startDate);
    const endFormatted = formatDate(expiryDateObj);
    const year = expiryDateObj.getFullYear();

    return `Valid until ${endFormatted} ${year}`;
  };

  // Get discount info with date range
  const getDiscountInfo = (
    expiryDate: string | null,
    discountCode: string | null,
  ) => {
    if (!expiryDate || !discountCode || isDiscountExpired) return null;

    const dateRange = getDateRange(expiryDate);
    const percentage = getDiscountPercentage(discountCode);

    return {
      dateRange,
      percentage,
    };
  };

  const discountInfo = getDiscountInfo(
    birthdayValues.expiryDate,
    birthdayValues.discount,
  );

  const heroSectionProps = {
    name: isDiscountExpired ? '' : birthdayValues.name ?? '',
    title: isDiscountExpired
      ? `Your birthday treat has ended`
      : 'Happy Birthday',
    subtitle: isDiscountExpired
      ? 'But feel free to explore, everything you need is still here.'
      : `For everything you've achieved and everything you're about to take on, enjoy ${getDiscountPercentage(
          birthdayValues.discount || '15',
        )}% off on all Ultrahuman products.`,
    discountInfo,
  };

  // Create discount config if discount is available and not expired
  const discountConfig =
    birthdayValues.discount && !isDiscountExpired
      ? {
          india: {
            code: birthdayValues.discount,
            type: 'percentage' as const,
            amount: '0',
            percentage: getDiscountPercentage(
              birthdayValues.discount,
            ).toString(),
            value: getDiscountPercentage(birthdayValues.discount),
          },
          uae: {
            code: birthdayValues.discount,
            type: 'percentage' as const,
            amount: '0',
            percentage: getDiscountPercentage(
              birthdayValues.discount,
            ).toString(),
            value: getDiscountPercentage(birthdayValues.discount),
          },
          row: {
            code: birthdayValues.discount,
            type: 'percentage' as const,
            amount: '0',
            percentage: getDiscountPercentage(
              birthdayValues.discount,
            ).toString(),
            value: getDiscountPercentage(birthdayValues.discount),
          },
          default: {
            code: birthdayValues.discount,
            type: 'percentage' as const,
            amount: '0',
            percentage: getDiscountPercentage(
              birthdayValues.discount,
            ).toString(),
            value: getDiscountPercentage(birthdayValues.discount),
          },
        }
      : null;

  const productSectionProps = {
    code: 'birthday',
    ring_active: true,
    m1_active: true,
    home_active: true,
    blood_vision_active: country === 'US' ? true : false,
    all_products_active: true,
    alternateUI: false,
    discount_config: discountConfig,
  };

  return (
    <>
      <HeroSection {...heroSectionProps} />
      <ProductSection {...productSectionProps} />
    </>
  );
}

export default Birthday;
